import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import '../PrivacyPolicy/PrivacyPolicy.css';

const RiskDisclosure = () => {
  return (
    <>
      <Helmet>
        <title>Risk Disclosure — Azamra</title>
        <meta name="description" content="Risk Disclosure Statement for tokenized real-world assets (RWA) issued or facilitated by Azamra Financial Technologies PLC." />
        <meta property="og:title" content="Risk Disclosure — Azamra" />
        <meta property="og:url" content="https://www.azamra.com/risk-disclosure" />
        <link rel="canonical" href="https://www.azamra.com/risk-disclosure" />
      </Helmet>
      <Header />

      <section className="legal-hero-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} md={10} xs={12} className="text-center">
              <h1 className="legal-hero-title">Risk Disclosure Statement</h1>
              <p className="legal-hero-subtitle">
                Tokenized Real-World Assets (RWA)
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="legal-content-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} md={10} xs={12}>

              <p className="legal-intro">
                Investing in <strong>tokenized real-world assets</strong> involves significant risks. By engaging with
                Azamra Financial Technologies PLC ("Azamra"), its platforms, or any tokenized instruments
                issued or facilitated through our infrastructure, investors acknowledge and accept the
                following risks:
              </p>

              <div className="legal-divider" />

              <h2 className="legal-section-title">1. Market Risk</h2>
              <p className="legal-body">
                The value of tokenized assets may fluctuate due to market conditions, macroeconomic
                factors, regulatory changes, or shifts in investor sentiment. Past performance of underlying
                assets does not guarantee future results.
              </p>

              <h2 className="legal-section-title">2. Regulatory and Legal Risk</h2>
              <p className="legal-body">
                Tokenization is an emerging field. Regulatory frameworks in Cameroon, the CEMAC region,
                and international jurisdictions continue to evolve. Changes in laws, licensing requirements,
                or supervisory actions may affect the issuance, trading, transferability, or redemption of
                tokenized assets.
              </p>

              <h2 className="legal-section-title">3. Technology and Cybersecurity Risk</h2>
              <p className="legal-body">
                Tokenized assets rely on blockchain and digital infrastructure. These systems may be
                exposed to cybersecurity threats, smart-contract vulnerabilities, operational failures, or
                network disruptions. While Azamra implements industry-standard safeguards, no system
                is entirely immune to technical risks.
              </p>

              <h2 className="legal-section-title">4. Liquidity Risk</h2>
              <p className="legal-body">
                Tokenized assets may not always have an active secondary market. Investors may face
                delays or difficulties when attempting to sell or redeem their tokens, and there is no
                guarantee of liquidity at any given time.
              </p>

              <h2 className="legal-section-title">5. Custody and Key Management Risk</h2>
              <p className="legal-body">
                Ownership of tokenized assets may depend on secure management of digital wallets and
                private keys. Loss, theft, or compromise of access credentials may result in irreversible
                loss of assets.
              </p>

              <h2 className="legal-section-title">6. Counterparty and Operational Risk</h2>
              <p className="legal-body">
                Tokenized instruments may depend on third-party service providers, custodians, or issuers.
                Failures, insolvency, or operational issues affecting these parties may impact the value or
                accessibility of the tokenized assets.
              </p>

              <h2 className="legal-section-title">7. Underlying Asset Risk</h2>
              <p className="legal-body">
                Tokenized assets derive their value from real-world assets such as government securities,
                commodities, receivables, or infrastructure-backed instruments. Any deterioration in the
                performance, creditworthiness, or legal standing of the underlying asset may negatively
                affect the token.
              </p>

              <div className="legal-divider" />

              <div className="legal-notice-block">
                <h3 className="legal-notice-title">Important Notice</h3>
                <p className="legal-body">
                  This disclosure does <strong>not</strong> constitute financial advice, an offer to sell, or a solicitation to
                  purchase any tokenized asset. Investors should conduct independent due diligence and
                  consult qualified financial, legal, and tax advisors before making investment decisions.
                </p>
                <p className="legal-body" style={{ marginBottom: 0 }}>
                  Azamra Financial Technologies PLC is committed to transparency, regulatory compliance,
                  and responsible innovation. However, all investments, especially in emerging digital asset
                  markets, carry inherent risks that investors must carefully evaluate.
                </p>
              </div>

            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};

export default RiskDisclosure;
